export default "__VITE_ASSET__3f1c3c11__"